import camelCase from 'lodash/camelCase';
import snakeCase from 'lodash/snakeCase';

import { isDateString } from './date';


export const isObjectEmpty = (value: any) => {
  if (typeof value === 'object') {
    return Object.keys(value).length === 0;
  }

  return false;
};

export const cleanObject = (obj: Record<any, any>) => {
  return Object.keys(obj).reduce<Record<string, any>>((newObj, key) => {
    if(![null, undefined, ''].includes(obj[key])) {
      newObj[key] = obj[key];
    }
    return newObj;
  }, {});
};

const processSnakeObjectKeyValue = (value: any, func: (value: any) => any): any => {

  if (!value) {
    return value;
  }

  if (Array.isArray(value)) {
    return value.map((v) => processSnakeObjectKeyValue(v, func));
  }

  if (value instanceof Date) {
    return value.toISOString();
  }

  if (typeof value === 'object') {
    return func(value);
  }

  return value;
};

export const snakizeObject = <T>(obj: Record<string, any>): T => {
  // @ts-ignore
  return Object.keys(obj).reduce(
    (result, key) => ({
      ...result,
      [snakeCase(key)]: processSnakeObjectKeyValue(obj[key], snakizeObject),
    }),
    {},
  );
};

const processCamelObjectKeyValue = (value: any, func: (value: any) => any): any => {

  if (!value) {
    return value;
  }

  if (Array.isArray(value)) {
    return value.map((v) => processCamelObjectKeyValue(v, func));
  }

  if (typeof value === 'object') {
    return func(value);
  }

  if (isDateString(value)) {
    return new Date(value);
  }

  return value;
};

export const camelizeObject = <T>(obj: Record<string, any>): T => {
  // @ts-ignore
  return Object.keys(obj).reduce(
    (result, key) => ({
      ...result,
      [camelCase(key)]: processCamelObjectKeyValue(obj[key], camelizeObject),
    }),
    {},
  );
};
